import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import "./CommonStyle.css";
import CountryFlag from "../Common/CountryFlag";
import { useFeatureFlag } from "../../util/oneXp/useFeatureFlag";
import { COUNTRY_CODE_MAP, COUNTRY_NAME, ENABLED_COUNTRIES } from "../Common/constants";
import { getEnabledEurozoneEnabledCountries } from "../../util/oneXp/featureFlagPropertyUtils";
import { replaceEmptySpace } from "../Common/utils";

const CountryDropdown = (props) => {
  const { t } = useTranslation("common");
  const { country, handleCountrySelectChange, languageSelected = "en" } = props;
  const { enabled: isEurozoneEnabled, properties: eurozoneEnabledProperties } =
    useFeatureFlag("GES_EUROZONE_ENABLED");
  const enabledEurzoneCountries = useMemo(() => {
    return getEnabledEurozoneEnabledCountries(eurozoneEnabledProperties);
  }, [eurozoneEnabledProperties]);

  const countryList = useMemo(() => {
    const list = [...ENABLED_COUNTRIES];
    if (!isEurozoneEnabled || !enabledEurzoneCountries) return list;
    if (enabledEurzoneCountries.has(COUNTRY_CODE_MAP.SWEDEN) && !list.includes(COUNTRY_NAME.SWEDEN)) {
      list.push(COUNTRY_NAME.SWEDEN);
    }
    if (enabledEurzoneCountries.has(COUNTRY_CODE_MAP.NORWAY) && !list.includes(COUNTRY_NAME.NORWAY)) {
      list.push(COUNTRY_NAME.NORWAY);
    }
    if (enabledEurzoneCountries.has(COUNTRY_CODE_MAP.INTERNATIONALEUROCARD) && !list.includes(COUNTRY_NAME.INTERNATIONALEUROCARD)) {
      list.push(COUNTRY_NAME.INTERNATIONALEUROCARD);
    }
    return list;
  }, [isEurozoneEnabled, enabledEurzoneCountries]);

  const options = [
    { value: "", label: <div>{t("newuser.selectCountry")}</div> },
    ...countryList.map((countryKey) => {
      const transKey = replaceEmptySpace(countryKey);
      const labelText = t(`access.${transKey}`) || countryKey;
      const code = COUNTRY_CODE_MAP[transKey] || "";
      return {
        value: countryKey,
        label: <CountryFlag country={countryKey} countryCode={code} transCountry={labelText} />,
        data: { countryKey, labelText },
      };
    }),
  ];

  const selectedOption = options.find((o) => o?.data?.labelText === country) || options[0];

  const filteredOptions = languageSelected === "en"
    ? options
    : options.filter((o) => o.data?.countryKey !== COUNTRY_NAME.UNITEDKINGDOM);

  return (
    <Select
      className="select-country-dropdown"
      placeholder={t("newuser.country")}
      options={filteredOptions}
      value={selectedOption}
      onChange={(option) => {
        handleCountrySelectChange("country", option?.data?.labelText);
      }}
      styles={{
        control: (base, state) => ({
          ...base,
          border: "1px solid #C8C9C7",
          height: "50px",
          background: "#F7F8F9",
          boxShadow: "none",
          "&:hover": {
            border: "1px solid #C8C9C7",
          },
        }),
      }}
    />
  );
};

export default CountryDropdown;